import ParallelCoordsViz from '../vizs/ParallelCoordsViz'
import BaseComponent from './BaseComponent'

/**
 * # {componentLabel} (`class {componentClassName}`)
 * Parallel coordinates is a visualization technique used to plot individual data elements across many dimensions. Each of the dimensions corresponds to a vertical axis and each data element is displayed as a series of connected points along the dimensions/axes.
 * 
 * ### Example Usage
 * ```javascript
 *   
 *   import {ParallelCoords} from 'sdv-lib'
 *   
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new ParallelCoords($el, data, config);
 *   
 * ```
 * 
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with 3 or more columns.
 * 
 * Each row represents a line. 
 * 
 * The first columns represents the id/label of the line.
 * 
 * Each other column represents a dimension.
 * 
 * | id           |  dim1 |  dim2  |  dim3  |
 * | --------     | ------ |  ------  |  ------  |
 * |   line 1     |    22.4|      15.4|      43.2|
 * |   line 2     |    52.3|      29.3|      12.8|
 * |   line 3     |    12.8|      34.1|      61.4|
 * |   line 4     |    26.0|      12.3|      14.5|
 * 
 * {.data-table}
 * 
 *
 * */
export default class ParallelCoordsComponent extends BaseComponent {

  static vizClass = ParallelCoordsViz
  static componentLabel = "Parallel coordinates"
  static dataFormat = [
    {index:0, axis:'', label:'id', types:[String], role:'id',roleLabel:'Line name'},
    {index:-1, axis:'y', label:'Dimension', types:[Number], role:'value',roleLabel: 'Dimension value'}
  ]
  constructor ($root,config,data) {
    super($root,config,data)
  }

  static defaultConfig = {
    title: this.componentLabel,
  }
}
